import { useMutation, useQueryClient } from '@tanstack/react-query';
import { OasBooking } from '@acp/shared';
import { submitBookingData } from '../../../booking/service';

type UseBookingSubmissionOpts = {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
};

function useConfirmBookingMutation(
    propertyId: string | number,
    opts: UseBookingSubmissionOpts = {}
) {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: (data: OasBooking) => submitBookingData(data),
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: ['notices', propertyId],
            });

            void queryClient.removeQueries({
                queryKey: ['notices', propertyId, 'booking'],
            });

            if (opts.onSuccess !== undefined) {
                opts.onSuccess();
            }
        },
        onError: (error) => {
            if (opts.onError !== undefined) {
                opts.onError(error);
            }
        },
    });

    return query;
}

export { useConfirmBookingMutation };
